<app-access-manager [namespace]="namespace">
<div>
  <div
    [hidden]="
      selectedUser != undefined || addingUser || editingUser || editingGroup
    "
  >
    <div style="display: flex; align-items: start; gap: 20px">
      <div style="flex-grow: 3">
        <app-filterable-table
          #userTable
          [tableView]="tableView"
          [title]="'USERS'"
          (selectedRecord)="handleUserSelected($event)"
          [toolbarButtonText]="'Add New User'"
          (toolbarButtonClick)="btnAddUser_click()"
          [options]="tableViewOptions"
        ></app-filterable-table>
      </div>

      <div style="flex-grow: 1; flex-shrink: 1; white-space: nowrap; margin: 19px 20px 0 0;">
        <h1  class="cpo-table-title cpo-toolbar__title" style="margin-bottom: 20px;">USER GROUPS</h1>
        <table class="cpo-selectable-table">
          <thead>
            <tr class="cpo-selectable-table__header-row">
              <th class="no-sort">Name</th>
              <th></th>
            </tr>
          </thead>
          @for (
            item of this.groups;
            track item;
            let even = $even;
            let odd = $odd
          ) {
            <tr [ngClass]="{ even: even, odd: odd }" class="cpo-selectable-table__row">
              <td>{{ item }}</td>
              <td>
                <app-icon style="cursor: pointer;" title="Edit User Group" [color]="'var(--color-action-icon)'"
                  (click)="btnSelectGroup_click(item)" type="Edit"></app-icon>
              </td>
            </tr>
          }
        </table>
      </div>          

    </div>
  </div>

  <app-edit-user *ngIf="addingUser"
    #newUserForm
    [enableEditing]="true"
    [initialMode]="formMode.Edit"
    (cancelled)="handleUserCancelled()"
    (saved)="handleUserSaved($event)"
  ></app-edit-user>

  <app-edit-user *ngIf="selectedUser"
    [user]="selectedUser"
    [enableEditing]="true"
    [initialMode]="formMode.Edit"
    (cancelled)="handleUserCancelled()"
    (saved)="handleUserSaved($event)"
  ></app-edit-user>

  <div [hidden]="!editingGroup">
    <app-edit-user-group
      [groupName]="selectedGroup"
      (cancelled)="handleUserGroupCancelled()"
    ></app-edit-user-group>
  </div>

  <!--
  <div [hidden]="!addingUser && !editingUser">
    <input type="button" value="Cancel" class="button_primary button_var_2 button_right-spacing" (click)="btnCancel_click()" />
    <input type="button" value="Save" class="button_primary button_var_2" (click)="btnSave_click()" />

  </div>
  -->
</div>
</app-access-manager>